import BlogFortySevenContainer from "./container/BlogFortySevenContainer";
export default BlogFortySevenContainer;
